import Link, { LinkProps } from '@/components/Link';
import React from 'react';

export default React.forwardRef(
  (props: LinkProps, ref: React.ForwardedRef<HTMLAnchorElement>) => (
    <Link underline="none" naked {...props} ref={ref} />
  ),
);
